import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=2061ba06&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=2061ba06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061ba06",
  null
  
)

export default component.exports